import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-star-line"></i>
            编辑精选
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            为你甄选最值得观看的高分影片与热门剧集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 6).map((card, idx) => (
            <article
              key={idx}
              className={`bg-background-50 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer transition-all duration-300 hover:-translate-y-1 ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`${idx === 0 ? 'flex flex-col sm:flex-row' : 'flex flex-col'}`}>
                <div className={`overflow-hidden ${idx === 0 ? 'sm:w-1/2' : 'w-full'}`}>
                  <img
                    src={card.image}
                    alt={card.title}
                    className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${idx === 0 ? 'h-48 sm:h-full aspect-auto' : 'h-48'}`}
                  />
                </div>
                <div className={`p-5 ${idx === 0 ? 'sm:w-1/2' : ''}`}>
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                    {card.tag}
                  </span>
                  <h3 className="text-foreground-900 font-semibold text-sm md:text-base mb-2 leading-snug">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6">
          <article className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer transition-all duration-300 hover:-translate-y-1 flex flex-col sm:flex-row">
            <div className="sm:w-1/3 overflow-hidden">
              <img
                src={cardsData[6].image}
                alt={cardsData[6].title}
                className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 sm:w-2/3 flex flex-col justify-center">
              <span className="inline-block px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 w-fit">
                {cardsData[6].tag}
              </span>
              <h3 className="text-foreground-900 font-semibold text-sm md:text-base mb-2 leading-snug">
                {cardsData[6].title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {cardsData[6].desc}
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}